import React from 'react';
import BreadCrumbs from '.';
import BreadCrumbsLoader from './Loader';
const BreadCrumbsContainer = ({ loading, ...breadCrumbsProps }) => {
    return loading ? (React.createElement(BreadCrumbsLoader, { ...breadCrumbsProps })) : (React.createElement(BreadCrumbs, { visibleCount: 1, ...breadCrumbsProps }));
};
export default BreadCrumbsContainer;
